<template>
   <div :class="'circle-container glyphicon ' + getIconClass()"></div>
</template>

<script>
export default {
  props: ['event'],
  methods: {
    getIconClass () {
      let event = this.event
      let iconCls = ''
      if (event === 'note') {
        iconCls = 'glyphicon-file'
      } else if (event === 'reopen') {
        iconCls = 'glyphicon-open'
      } else if (event === 'deny') {
        iconCls = 'glyphicon-thumbs-down'
      } else if (event === 'processing') {
        iconCls = 'glyphicon-arrow-right'
      } else if (event === 'revert') {
        iconCls = 'glyphicon-erase'
      } else if (event === 'grant') {
        iconCls = 'glyphicon-thumbs-up'
      } else if (event === 'edit') {
        iconCls = 'glyphicon-edit'
      }
      return event + ' ' + iconCls
    }
  }
}
</script>

<style scoped lang="scss">
  
  $active: lighten(#4183c4, 5%);
  $processing: lighten($active, 15%);
  $deny: lighten(red, 36%);
  $grant: lighten(green, 30%);

  .circle-container {
    display: inline-block;
    padding: 5px;
    border-radius: 50%;
    color: white;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */
  }

  .note {
    background: gray;
  }
  .deny {
    background: $deny;
  }
  .processing {
    background: $active;
  }
  .revert {
    background: $active;
  }
  .grant {
    background: $grant;
  }
  .reopen {
    background: $active;
  }
  .edit {
    background: rgb(255, 145, 0);
  }
</style>



// WEBPACK FOOTER //
// CommentIcon.vue?6f7445d0